import axios from 'axios';

export const getWhatsappStatus = () => async () => {
  const res = await axios.get('/api/whatsapp/status');
  return res.data;
};

export const initializeWhatsapp = () => async () => {
  const res = await axios.post('/api/whatsapp/initialize');
  return res.data;
};

export const getWhatsappQueue = (params = {}) => async () => {
  const res = await axios.get('/api/whatsapp/queue', { params });
  return res.data;
};

export const getWhatsappQueueStats = () => async () => {
  const res = await axios.get('/api/whatsapp/queue/stats');
  return res.data;
};

export const sendWhatsappBatch = (customerIds, message) => async () => {
  const res = await axios.post('/api/whatsapp/send', { customerIds, message });
  return res.data;
};

export const pauseWhatsappQueue = () => async () => {
  const res = await axios.post('/api/whatsapp/queue/pause');
  return res.data;
};

export const resumeWhatsappQueue = () => async () => {
  const res = await axios.post('/api/whatsapp/queue/resume');
  return res.data;
};

export const updateWhatsappConfig = (config) => async () => {
  const res = await axios.put('/api/whatsapp/config', config);
  return res.data;
};
